import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { CountryFlag } from "@/shared/ui";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

export const LanguageSwitcher: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(newLang);
    localStorage.setItem("language", newLang);
  };

  const currentLang = i18n.language || "es";
  const languages = [
    { code: "es", label: "ES", flag: "es" },
    { code: "en", label: "EN", flag: "us" },
  ];

  const currentLanguage =
    languages.find((lang) => lang.code === currentLang) || languages[0];
  const otherLanguage =
    languages.find((lang) => lang.code !== currentLang) || languages[1];

  return (
    <motion.button
      whileTap={{ scale: 0.98 }}
      onClick={toggleLanguage}
      className={`${className} bg-white flex items-center justify-between gap-1 sm:gap-2 px-2 sm:px-3 py-2 sm:py-3 rounded-lg border border-tiber-800 shrink-0`}
      aria-label={`Change language to ${otherLanguage.label}`}
      title={`Switch to ${otherLanguage.label}`}
    >
      <div className="flex items-center space-x-4">
        <CountryFlag
          countryCode={currentLanguage.flag}
          size="1em"
          title={currentLanguage.label}
        />
        <span className="text-sm font-semibold text-tiber-900">
          {currentLanguage.label}
        </span>
      </div>
      <div className="flex items-center space-x-1">
        <ChevronRightIcon className="w-4 h-4 text-tiber-900" />
      </div>
      <CountryFlag
        countryCode={otherLanguage.flag}
        size="0.75em"
        title={otherLanguage.label}
      />
    </motion.button>
  );
};
